/**
 * Examples.
 *
 * ```
 * f(0, 'apple') -> 'apples'
 * f(1, 'apple') -> 'apple'
 * f(2, 'apple') -> 'apples'
 * f(5, 'apple') -> 'apples'
 *
 * f(0, 'an apple has', 'apples have') -> 'apples have'
 * f(1, 'an apple has', 'apples have') -> 'an apple has'
 * f(2, 'an apple has', 'apples have') -> 'apples have'
 * f(5, 'an apple has', 'apples have') -> 'apples have'
 * ```
 */
export function plural(quantity: number, singular: string, plural: string = singular + 's') {
  return quantity === 1 ? singular : plural;
}
